<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <button mat-raised-button routerLink="/sites" class="m-1 mr-2">
      <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('sites.plural', 'Sites') }}
    </button>
  </nav>

  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <span class="navbar-brand">{{ utils.getLangTerm('child-sites.plural', 'Subsites') }}</span>

    <span class="mr-auto">

      <ng-container *ngIf="canCreate">
        <button
          mat-raised-button
          color="primary"
          [routerLink]="'/sites/' + parent_site_id + '/children/new/edit/details'"
          class="m-1 mr-2"
          id="add">
          <mat-icon>add</mat-icon> Add
        </button>

        <button mat-raised-button class="m-1 mr-2" routerLink="/sites/importer" [queryParams]="{ parent_site_id: parent_site_id }" matTooltip="Upload a CSV of {{ utils.getLangTerm('child-sites.plural', 'Subsites') }} to mass insert.">
            <mat-icon>cloud_upload</mat-icon> Import
        </button>
      </ng-container>

      <!-- The mat-menu and its trigger share one guard: Angular Material renders mat-menu content in a CDK overlay, so an unguarded mat-menu leaks into the DOM. -->
      <ng-container *ngIf="canView">
        <mat-menu #appMenu="matMenu">
          <button mat-menu-item (click)="dataSource.selectAllToggle()">
            <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
            {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
          </button>

          <button mat-menu-item (click)="dataSource.onExport('csv')">
            <mat-icon>cloud_download</mat-icon> Export {{ dataSource.selection.hasValue() ? '(' + dataSource.selection.selected.length + ') Selected' : 'All' }} to CSV
          </button>

          <button *ngIf="canCreateMessages" mat-menu-item (click)="composeNewMessage()">
            <mat-icon>send</mat-icon>
            Send Message {{ dataSource.selection.hasValue() ? 'to (' + dataSource.selection.selected.length + ') Selected' : '(0)' }}
          </button>

          <button *ngIf="canDelete" mat-menu-item (click)="onRemoveSelected()" [disabled]="!dataSource.selection.hasValue()">
            <mat-icon>delete</mat-icon> Delete Selected
          </button>
        </mat-menu>

        <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect and/or send messages." style="min-width: 150px">
          <mat-icon>more_vert</mat-icon>
          List Menu
        </button>
      </ng-container>
    </span>

    <ng-container *ngIf="canView">
      <button mat-raised-button class="m-1 mr-lg-3" (click)="onFilter()" matTooltip="Click this button to display filter options.">
        <mat-icon>filter_list</mat-icon> Filter
      </button>

      <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
        <input
          class="form-control ml-0 mr-2 my-1"
          type="search"
          [(ngModel)]="dataSource.search"
          name="search"
          placeholder="Search"
          aria-label="Search"
          id="search-input"
          matTooltip="Search for {{ utils.getLangTerm('child-sites.plural', 'Subsites').toLowerCase() }} by name or location" />

        <button
          mat-raised-button
          color="secondary"
          type="submit"
          class="mx-0 my-1"
          matTooltip="Run the current search"
          id="search-button">
          <mat-icon>search</mat-icon> Search
        </button>
      </form>
    </ng-container>
  </nav>

  <ng-container *ngIf="canView; else noViewPermissions">

    <app-tags-filter *ngIf="canViewTags" (tagsFilterOutput)="getOutputTagsFilter($event)"></app-tags-filter>

    <div class="mat-elevation-z8 scroll-box">
      <table mat-table [dataSource]="dataSource" matSort matSortActive="name" matSortDirection="asc" matSortDisableClear>
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
            <mat-checkbox
              (change)="$event ? dataSource.selectAllToggle() : null"
              [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
              [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()"
              matTooltip="Toggle selecting all records on this page.">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? dataSource.selection.toggle(row.id) : null"
              [checked]="dataSource.selection.isSelected(row.id)"
              matTooltip="Select '{{row.name}}' for deletion.">
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- ID Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              matTooltip="Toggle sorting by ID">#</th>
          <td mat-cell *matCellDef="let element">
            {{ element.id }}
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              matTooltip="Toggle sorting by Name">Name</th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="element?.parent_site">
              <small style="display: block;">
                <a [routerLink]="utils.prepareSiteRelatedLink(element?.parent_site?.id, null, canEdit ? 'edit/details' : 'view/details')">
                  {{ element?.parent_site?.name || '' }}
                </a>
              </small>
            </ng-container>
            <mat-icon *ngIf="element?.parent_site_id" style="font-size: 16px;">subdirectory_arrow_right</mat-icon>
            <a [routerLink]="utils.prepareSiteRelatedLink(element?.id, element?.parent_site?.id, canEdit ? 'edit/details' : 'view/details')">
              {{ (element?.name | ellipsis: ['30']) || '' }}
            </a>
          </td>
        </ng-container>

        <!-- Address Column -->
        <ng-container matColumnDef="location">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              matTooltip="Toggle sorting by Address">Address</th>
          <td mat-cell *matCellDef="let element">
            {{ element.location | ellipsis: ['30'] }}
          </td>
        </ng-container>

        <!-- Type Column -->
        <ng-container matColumnDef="site_type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              matTooltip="Toggle sorting by Type">Type</th>
          <td mat-cell *matCellDef="let element">
            <a (click)="onSiteTypeFilter(element.site_type)"
               matTooltip="Filter records by {{element.site_type}}">
              {{ element.site_type }}
            </a>
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="site_status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              matTooltip="Toggle sorting by Status">Status</th>
          <td mat-cell *matCellDef="let element">
            <a (click)="onSiteStatusFilter(element.site_status)"
               matTooltip="Filter records by {{element.site_status}}">
              {{ element.site_status }}
            </a>
          </td>
        </ng-container>

        <!-- Geofence Column: Yes/No -->
        <ng-container matColumnDef="geofence">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              matTooltip="Toggle sorting by Geofenced">Geofenced</th>
          <td mat-cell *matCellDef="let element">
            {{ element.geofence ? 'Yes' : 'No' }}
          </td>
        </ng-container>

        <!-- Risk Level Column -->
        <ng-container matColumnDef="site_risk_assessment">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              matTooltip="Toggle sorting by risk level.">Risk Level</th>
          <td mat-cell *matCellDef="let element">
          <span [class]="utils.getSiteRiskStatusTextColor(element.site_risk_assessment)">
            {{ element.site_risk_assessment | titlecase }}
          </span>
          </td>
        </ng-container>

        <!-- Date Created Column -->
        <ng-container matColumnDef="date_created">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the date the record was created.">Created At</th>
          <td mat-cell *matCellDef="let element">
            {{ (element.date_created * 1000) | timezoneConvertMedium }}
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef [style.width.px]="300">
            Actions
          </th>
          <td mat-cell *matCellDef="let element">
            <button type="button" mat-button [routerLink]="utils.prepareSiteRelatedLink(element.id, element.parent_site_id, 'view/details')">
              View
            </button>

            <button *ngIf="canEdit" type="button" mat-button [routerLink]="utils.prepareSiteRelatedLink(element.id, element.parent_site_id, 'edit/details')">
              Edit
            </button>

            <button *ngIf="canDelete" type="button" mat-button (click)="onRemove(element.id)">
              Delete
            </button>

            <button *ngIf="canCreate" type="button" mat-button (click)="onCloneSite(element.id)">
              Clone
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator
        [length]="dataSource?.total | async"
        [pageSize]="dataSource.limit"
        [pageSizeOptions]="dataSource.pageSizeOptions"
        showFirstLastButtons>
      </mat-paginator>
    </div>
  </ng-container>

  <ng-template #noViewPermissions>
    <div class="alert alert-warning m-3" role="alert">
      <mat-icon class="align-middle mr-2">info</mat-icon>
      You do not have permission to view {{ utils.getLangTerm('child-sites.plural', 'Subsites') | lowercase }}.
      <span *ngIf="canCreate">You can still create new {{ utils.getLangTerm('child-sites.plural', 'Subsites') | lowercase }} using the button above.</span>
      <span *ngIf="!canCreate">Please contact your administrator to request access.</span>
    </div>
  </ng-template>
</div>
